module.exports = __webpack_public_path__ + "static/media/BT_colorpalette.1f2a5ac2.sketch";